import React from "react";
import "../../styles/loading-spinner.css";
const LoadingSpinner = _ref => {
    let { color = "makroOrange" } = _ref;
    return /*#__PURE__*/ React.createElement("div", {
        className: "lds-ellipsis"
    }, /*#__PURE__*/ React.createElement("div", {
        className: `bg-${color}`
    }), /*#__PURE__*/ React.createElement("div", {
        className: `bg-${color}`
    }), /*#__PURE__*/ React.createElement("div", {
        className: `bg-${color}`
    }), /*#__PURE__*/ React.createElement("div", {
        className: `bg-${color}`
    }));
};
export default LoadingSpinner;
